export const defaultData = [
  {
    id: 'user_name',
    name: '氏名',
    identifier: null,
    data_type: 'string',
    input_group: 'account',
    input_position: null,
    input_question: '氏名',
    input_type: 'text',
    input_validation_rule: 'required',
    input_note: null,
    input_example: '山田 太郎',
    unit: null,
    display_format_type: null,
    parentId: null,
    options: [],
    values: [],
  },
  {
    id: 'tel',
    name: '電話番号',
    identifier: null,
    data_type: 'string',
    input_group: 'account',
    input_position: null,
    input_question: '電話番号',
    input_type: 'text',
    input_validation_rule: 'required|tel',
    input_note: null,
    input_example: '080-0000-0000',
    unit: null,
    display_format_type: null,
    parentId: null,
    options: [],
    values: [],
  },
];
